import React, { FC } from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import 'assets/styles/layout.less';

const { Header, Content } = Layout;

interface Props {
  children?: React.ReactNode;
}

const ContentLayout: FC = ({ children }: Props) => {
  return (
    <LayoutContainer>
      <HeaderContainer>SIS</HeaderContainer>
      <Content>{children}</Content>
    </LayoutContainer>
  );
};

const HeaderContainer = styled(Header)`
  width: 100%;
  background-color: transparent;
  height: 200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  font-weight: bold;
`;

const LayoutContainer = styled(Layout)`
  height: 100vh;
  background-color: #ffffff;

  @media (min-width: 768px) {
    padding-top: 20px;
  }
`;

export default ContentLayout;
